import React from "react";
import { InView } from "@tennr/frontend/components/InView";
import { CaseStudiesCarousel } from "@tennr/frontend/components/CaseStudiesCarousel";
import { CaseStudyCard } from "@tennr/frontend/components/CaseStudyCard";
import { Heading } from "@tennr/frontend/components/Heading";
import "./CaseStudiesCarouselSection.css";
import type { CaseStudy as SanityCaseStudy } from "@tennr/frontend/sanity.types";
import { urlForImage } from "@tennr/frontend/lib/sanity";
import { Button } from "@tennr/frontend/components/Button";

export const CaseStudiesCarouselSection: React.FC<{ caseStudies: SanityCaseStudy[] }> = ({ caseStudies }) => {
  return (
    <section className="case-studies-carousel-section section-y">
      {/* Carousel Component */}
      <CaseStudiesCarousel caseStudies={caseStudies} />

      {/* Grid Section */}
      <div id="case-studies" className="case-studies-grid-section">
        <div className="case-studies-grid-heading">
          <InView delay={0.1}>
            <Heading
              title="READ MORE"
              heading="Case studies across subspecialties"
              position="center"
              variant="hero"
              dark
              width={550}
            />
          </InView>
        </div>

        <div className="case-studies-grid">
          {caseStudies.map((study) => (
            <InView key={study._id}>
              <CaseStudyCard
                logo={urlForImage(study.companyLogo) || ""}
                title={study.title || ""}
                company={study.company || ""}
                slug={study.slug?.current || ""}
              />
            </InView>
          ))}
        </div>
      </div>
    </section>
  );
};
